import { clsx } from 'clsx';
import { type FC, type JSX, useEffect, useMemo, useState } from 'react';

import { type IPromo } from '../../../../types/promos';
import { OffersCountLink } from '../OffersCountLink';

import styles from './styles.css';

interface IRowsExpanderProps {
  error: JSX.Element;
  mortgageSeoLink: JSX.Element;
  content: (promo: IPromo[]) => JSX.Element;
  promos: IPromo[];
  onDisplayedOffersChange: (promo: IPromo[]) => void;
}

const VISIBLE_ROWS_COUNT = 5;

export const RowCountController: FC<IRowsExpanderProps> = ({
  content,
  error,
  mortgageSeoLink,
  onDisplayedOffersChange,
  promos,
}) => {
  const [expanded, setExpanded] = useState(false);

  const displayedPromos = useMemo(() => (expanded ? promos : promos.slice(0, VISIBLE_ROWS_COUNT)), [expanded, promos]);
  const unvisibleRowsCount = promos.length - VISIBLE_ROWS_COUNT;
  const isCountLinkVisible = promos.length > VISIBLE_ROWS_COUNT;

  useEffect(() => {
    onDisplayedOffersChange(displayedPromos);
  }, [displayedPromos, onDisplayedOffersChange]);

  if (displayedPromos.length === 0) {
    return error;
  }

  return (
    <div className={styles['container']}>
      {content(displayedPromos)}
      <div className={clsx(styles['controls'], isCountLinkVisible && styles['controls-multiple'])}>
        {isCountLinkVisible && (
          <OffersCountLink count={unvisibleRowsCount} expanded={expanded} onClick={() => setExpanded(!expanded)} />
        )}
        {mortgageSeoLink}
      </div>
    </div>
  );
};
